// extracted by mini-css-extract-plugin
export var borderRadius = "_b6-4";
export var large = "_b6-3";
export var logoContainer = "_b6-0";
export var nameLogo = "_b6-2";
export var small = "_b6-1";